import { cn } from '@/lib/utils';

/**
 * Shared visual chrome for wizard blocks.
 * Same styling in the creation wizard and in tournament detail edit modals.
 */
export const wizardBlockCardClassName = cn(
  'border-border bg-card text-card-foreground shadow-sm',
);

/** Layout without a Card wrapper (e.g. modals): bordered frame with padding. */
export const wizardBlockShellClassName = cn(
  'rounded-xl border border-border bg-card p-4 sm:p-5 text-card-foreground',
);
